import React from "react";
import { faAward } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faAward}
				title="Certifications"
				body={
					<div className="works-body">
						<div className="work spacer">
							<img
								src="./aws.svg"
								alt="aws"
								className="work-image"
							/>
							
							<div className="work-title">AWS Certified Solutions Architect - Associate</div>
							
							<a className="work-subtitle" href="https://www.credly.com/badges/d8256c02-fa34-4860-9940-272e0debfadd/public_url">
								<div className="">
									Credly link
								</div>
							</a>

							<div className="work-duration">May 2024</div>
						</div>
{/* 
						<div className="work spacer">
							<img
								src="./toke.jpg"
								alt="toke"
								className="work-image"
							/>
							<div className="work-title">Vortx QR Tokenizadora</div>
							<div className="work-subtitle">
								DevOps Engineer
							</div>
							<div className="work-duration">2023 - Present</div>
						</div>

						<div className="work spacer">
							<img
								src="./orbee.png"
								alt="orbee"
								className="work-image"
							/>
							<div className="work-title">Orbee</div>
							<div className="work-subtitle">
								DevOps Engineer
							</div>
							<div className="work-duration">2022 - Present</div>
						</div>

						<div className="work spacer">
							<img
								src="./qr.png"
								alt="qr-capital"
								className="work-image"
							/>
							<div className="work-title">QR Capital</div>
							<div className="work-subtitle">
								DevOps Engineer
							</div>
							<div className="work-duration">2022 - 2023</div>
						</div>

						<div className="work">
							<img
								src="./altbank.png"
								alt="alt.bank"
								className="work-image"
							/>
							<div className="work-title">alt.bank</div>
							<div className="work-subtitle">
								DevOps Engineer
							</div>
							<div className="work-duration">2021 - 2022</div>


						</div>

						<div className="work spacer">
							<div className="work-subtitle">
								QA Engineer
							</div>
							<div className="work-duration">2019 - 2021</div>
						</div>*/}
					</div> 
				}
			/>
		</div>
	);
};

export default Works;
